import type { FaireProductEntity } from "../../entity_types/product";

export const p_3ddteec8yz: FaireProductEntity = {
  token: "p_3ddteec8yz",
  type: "product",
  name: "Squeezed Heart Greeting Card",
  brandToken: "b_de884c62",
  brandName: "E. Frances Paper",
  imageUrl:
    "https://cdn.faire.com/fastly/2219f297724e284a988a51a8850cb56d3c64c33c5866e8bd7491c1b66424a506.png",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/d91cf727602fdf011ab5992d30b19c31fdc5c54b2d9ddb29e3abc71b12d23ca9.png",
  ],
  priceDollars: 3,
  description:
    "At E. Frances, we believe connection makes the world better. And happier! Our original artwork paired with just-right words warms the heart and helps make meaningful connections easier. Every card begins with a lovingly painted watercolor, and is then printed on luxurious heavyweight paper with brilliant color and, when featured, metallic foil accents.\n\nAnd because we think tiny details can make a big impact, you’ll always find a second illustration on the back of every card!",
  tags: [],
  msrpDollars: 6,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-06-21T23:37:14.804Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
